import React, { useState, useRef, useEffect } from "react";
import styles from "./carousel.module.css";
import formatarPreco from "../../utils/formatarPreco";

import imagem1 from "../../assets/img/ripaton/r_image_1.png";
import imagem2 from "../../assets/img/ripaton/r_image_2.png";
import imagem3 from "../../assets/img/ripaton/r_image_3.png";
import imagem4 from "../../assets/img/ripaton/r_image_4.png";
import imagem5 from "../../assets/img/ripaton/r_image_5.png";
import imagem6 from "../../assets/img/ripaton/r_image_6.png";
import imagem7 from "../../assets/img/ripaton/r_image_7.png";
import imagem8 from "../../assets/img/ripaton/r_image_8.png";


import ripatonVermelho from "../../assets/img/ripaton/r_image_1.png";
import ripatonChocolateDark from "../../assets/img/ripaton/ripaton-sunburst-chocolate-dark.png";
import ripatonChocolate from "../../assets/img/ripaton/ripaton-sunburst-chocolate.png";

interface CarouselProps {
  categoria: "INSTRUMENTOS" | "ACESSÓRIOS"; 
}


interface Image {
  id: number;
  src: string;
  alt: string;
  nome: string;
  preco: string;
  categoria: "INSTRUMENTOS" | "ACESSÓRIOS";
}

const imagens: Image[] = [
  {
    id: 0,
    src: imagem1,
    alt: "RIPATON Sunburst Preto",
    nome: "RIPATON Sunburst Preto",
    preco: "650",
    categoria: "INSTRUMENTOS",
  },
  {
    id: 1,
    src: imagem2,
    alt: "RIPATON Sunburst Chocolate",
    nome: "RIPATON Sunburst Chocolate",
    preco: "650",
    categoria: "INSTRUMENTOS",
  },
  {
    id: 2,
    src: imagem3,
    alt: "RIPATON Amarelo (Sunburst laranja e preto)",
    nome: "RIPATON Amarelo (Sunburst laranja e preto)",
    preco: "650",
    categoria: "INSTRUMENTOS",
  },
  {
    id: 3,
    src: imagem4,
    alt: "RIPATON Preto com flips em Madeira",
    nome: "RIPATON Preto com flips em Madeira",
    preco: "650",
    categoria: "INSTRUMENTOS",
  },
  {
    id: 4,
    src: imagem5,
    alt: "Bag Extra Luxo para Ripaton",
    nome: "Bag Extra Luxo para Ripaton",
    preco: "299",
    categoria: "ACESSÓRIOS",
  },
  {
    id: 5,
    src: imagem6,
    alt: "Semi Case com Bolsa e Alça para Ripaton",
    nome: "Semi Case com Bolsa e Alça para Ripaton",
    preco: "350",
    categoria: "ACESSÓRIOS",
  },
  {
    id: 6,
    src: imagem7,
    alt: "Suporte Regulável do Ripaton",
    nome: "Suporte Regulável do Ripaton",
    preco: "300",
    categoria: "ACESSÓRIOS",
  },
  {
    id: 7,
    src: imagem8,
    alt: "Talabarte Retrátil para Ripaton",
    nome: "Talabarte Retrátil para Ripaton",
    preco: "25",
    categoria: "ACESSÓRIOS",
  },
];

const Carousel: React.FC<CarouselProps> = ({ categoria }) => {
  const imagensFiltradas = imagens.filter((img) =>
    categoria === "INSTRUMENTOS" ? img.id <= 3 : img.id > 3
  );

  const [currentIndex, setCurrentIndex] = useState(0);
  const [mainImage, setMainImage] = useState<Image>(imagensFiltradas[0]);
  const slidesRef = useRef<HTMLDivElement | null>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const autoplayDelay = 5000;

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1040);
    };

    checkMobile();

    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);


  const [isMobile, setIsMobile] = useState(false);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
    if (slidesRef.current) {
      slidesRef.current.scrollTo({
        left: index * slidesRef.current.offsetWidth,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrentIndex(
        (prevIndex) => (prevIndex + 1) % Math.ceil(imagensFiltradas.length / 4)
      );
    }, autoplayDelay);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  useEffect(() => {
    if (slidesRef.current) {
      slidesRef.current.scrollTo({
        left: currentIndex * slidesRef.current.offsetWidth,
        behavior: "smooth",
      });
    }
  }, [currentIndex]);

  const [visibleGroups, setVisibleGroups] = useState(1);
  const totalGroups = Math.ceil(imagensFiltradas.length / 4);

  return (
    <>
      {isMobile ? (
       <div className={styles.carouselWrapper}>
       <div className={styles.carousel}>
         <div className={styles.carouselSlides} ref={slidesRef}>
           {Array.from({ length: totalGroups }, (_, groupIndex) => {
             if (groupIndex >= visibleGroups) return null;
     
             const groupimagensFiltradas = imagensFiltradas.slice(
               groupIndex * 4,
               groupIndex * 4 + 4
               
             );
     
             return (
               <div key={groupIndex} className={styles.carouselSlide}>
                 <div className={styles.slideContent}>
                   <div className={styles.thumbnailGrid}>
                     {groupimagensFiltradas.map((image, index) => (
                       <div
                         key={index}
                         className={styles.thumbnail}
                         onClick={() => setMainImage(image)}
                       >
                         <div className={styles.tummbnailContainer + " " + styles.tummbnailContainerMobile}>
                           <img src={image.src} alt={image.alt} />
                           <p>{image.nome}</p>
                           <p>
                             <b>{formatarPreco(image.preco)}</b>
                           </p>

                            <div className={styles.buttonWrapperMobile}>
                              <button
                                className={styles.buttonCustomMobile}
                                onClick={() =>
                                  window.open(
                                    "https://mkt.institutoripaxote.org.br/#modelos-ripaton"
                                  )
                                }
                              >
                                COMPRAR
                              </button>
                            </div>
                         </div>
                         
                       </div>
                     ))}
                   </div>
                 </div>
               </div>
             );
           })}
         </div>

            {/* <div className={styles.carouselNavdots}>
              <p className={styles.btnVerMais} onClick={() => setVisibleGroups(visibleGroups + 1)}>Ver mais</p>
            </div> */}
          </div>
        </div>
      ) : (
        <div className={styles.carouselWrapper}>
          <div className={styles.carousel}>
            <div className={styles.carouselSlides} ref={slidesRef}>
              {Array.from(
                { length: Math.ceil(imagensFiltradas.length / 4) },
                (_, groupIndex) => {
                  const groupimagensFiltradas = imagensFiltradas.slice(
                    groupIndex * 4,
                    groupIndex * 4 + 4
                  );

                  return (
                    <div key={groupIndex} className={styles.carouselSlide}>
                      <div className={styles.slideContent}>
                        <div className={styles.mainImage}>
                          <div>
                            <img src={mainImage.src} alt={mainImage.alt} />
                          </div>
                          <div className={styles.mainImageText}>
                            <p>{mainImage.nome}</p>
                            <p>
                              <b>{formatarPreco(mainImage.preco)}</b>
                            </p>
                            <div className={styles.buttonWrapper}>
                              <button
                                className={styles.buttonCustom}
                                onClick={() =>
                                  window.open(
                                    "https://mkt.institutoripaxote.org.br/#modelos-ripaton"
                                  )
                                }
                              >
                                COMPRAR
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className={styles.thumbnailGrid}>
                          {groupimagensFiltradas.map((image, index) => (
                            <div
                              key={index}
                              className={`${styles.thumbnail} 
                          ${mainImage.id === image.id ? styles.active : ""}`}
                              onClick={() => setMainImage(image)}
                            >
                              <div className={styles.tummbnailContainer}>
                                <img src={image.src} alt={image.alt} />
                                <p>{image.nome}</p>
                                <p>
                                  <b>{formatarPreco(image.preco)}</b>
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  );
                }
              )}
            </div>

            <div className={styles.carouselNavdots}>
              {Array.from(
                { length: Math.ceil(imagensFiltradas.length / 4) },
                (_, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    aria-label={`Slide ${index + 1}`}
                    aria-disabled={index === currentIndex}
                    className={index === currentIndex ? styles.activeDot : ""}
                  />
                )
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Carousel;
